import { InterfaceSend, StudentTestDeviceIF, TestAnswerSend } from '@/interfaces/wsInterface';

const WebsocketCourse = window.wsAppModule;
// 上报接口对象
export default {
  // 开始上课
  classBegin(arg: InterfaceSend) {
    arg.returnFunction = 'classBegin';
    window.wsAppModule.send(arg);
  },
  // 课堂记录
  classRecord(arg: InterfaceSend) {
    arg.returnFunction = 'classRecord';
    window.wsAppModule.send(arg);
  },
  // 学生状态   1 加入课堂
  classUserStatus(arg: InterfaceSend) {
    arg.returnFunction = 'classUserStatus';
    window.wsAppModule.send(arg);
  },
  // 单独禁言/取消禁言  1 禁言  2 取消禁言
  singleMute(arg: InterfaceSend) {
    arg.returnFunction = 'singleMute';
    window.wsAppModule.send(arg);
  },
  // 全部禁言/取消禁言
  allMute(arg: InterfaceSend) {
    arg.returnFunction = 'allMute';
    window.wsAppModule.send(arg);
  },
  // 学生发言
  studentSpeak(arg: InterfaceSend) {
    arg.returnFunction = 'studentSpeak';
    window.wsAppModule.send(arg);
  },
  // 弹幕设置
  classBarrage(arg: InterfaceSend) {
    arg.returnFunction = 'classBarrage';
    window.wsAppModule.send(arg);
  },
  // 发送弹幕
  sendBarrage(arg: InterfaceSend) {
    arg.returnFunction = 'sendBarrage';
    window.wsAppModule.send(arg);
  },
  // 开启抢答
  addRace(arg: InterfaceSend) {
    arg.returnFunction = 'addRace';
    window.wsAppModule.send(arg);
  },
  // 结束抢答
  finishRace(arg: InterfaceSend) {
    arg.returnFunction = 'finishRace';
    window.wsAppModule.send(arg);
  },
  // 参与抢答
  joinRace(arg: InterfaceSend) {
    arg.returnFunction = 'joinRace';
    window.wsAppModule.send(arg);
  },
  // 开启提问
  addAsk(arg: InterfaceSend) {
    arg.returnFunction = 'addAsk';
    window.wsAppModule.send(arg);
  },
  // 添加课堂记录
  addRecord(arg: InterfaceSend) {
    arg.returnFunction = 'addRecord';
    window.wsAppModule.send(arg);
  },
  // 发表话题评论
  addCommentReply(arg: InterfaceSend) {
    arg.returnFunction = 'addCommentReply';
    window.wsAppModule.send(arg);
  },
  // 删除话题评论
  deleteCommentReply(arg: InterfaceSend) {
    arg.returnFunction = 'deleteCommentReply';
    window.wsAppModule.send(arg);
  },
  // 开始上课 - 开始互动答题
  beginInteract(arg: InterfaceSend) {
    arg.returnFunction = 'beginInteract';
    window.wsAppModule.send(arg);
  },
  // 开始上课 - 结束互动答题
  closeInteract(arg: InterfaceSend) {
    arg.returnFunction = 'closeInteract';
    window.wsAppModule.send(arg);
  },
  // 更新互动答题数据
  updateInteract(arg: InterfaceSend) {
    arg.returnFunction = 'updateInteract';
    window.wsAppModule.send(arg);
  },
  // 老师端PPT翻页上报
  interactPptPage(arg: InterfaceSend) {
    arg.returnFunction = 'interactPptPage';
    window.wsAppModule.send(arg);
  },
  // 学生端上报请求PPT页码
  studentPptPage(arg: InterfaceSend) {
    arg.returnFunction = 'studentPptPage';
    window.wsAppModule.send(arg);
  },
  // 学生端是否疑问上报
  questionState(arg: InterfaceSend) {
    arg.returnFunction = 'questionState';
    window.wsAppModule.send(arg);
  },
  // 测试学生正在答题
  studentAnswer(arg: TestAnswerSend) {
    // @ts-ignore
    window.wsAppModule.send(arg, 'AttendClass.getTestPaper');
  },
  // 测试老师开启实时监控
  teacherTimerBegin(arg: InterfaceSend) {
    arg.returnFunction = 'teacherTimerBegin';
    window.wsAppModule.send(arg);
  },
  // 学生签到数据上报
  checkinAttence(arg: InterfaceSend) {
    arg.returnFunction = 'checkinAttence';
    window.wsAppModule.send(arg);
  },
  // 老师创建数据上报
  createAttence(arg: InterfaceSend) {
    arg.returnFunction = 'createAttence';
    window.wsAppModule.send(arg);
  },
  // 测试 => 多设备作答/单设备作答
  studentDeviceCheck(arg: StudentTestDeviceIF) {
    window.wsAppModule.send(arg, 'TestPaper.setTest');
  },
  //上报遥控器信息
  remoteData(arg: any) {
    // @ts-ignore
    window.wsAppModule.send(arg, 'AttendClass.remoteControl');
  },
};
